/* eslint-disable max-len */
import React from 'react';
import { oneOfType, node, func, object } from 'prop-types';
import _noop from 'lodash/noop';
import { Button } from '@one-thd/sui-atomic-components';

export const ZoomSvg = () => (
  <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.375 19.966C16.7584 21.2399 14.718 22 12.5 22C7.25329 22 3 17.7467 3 12.5C3 7.25329 7.25329 3 12.5 3C17.7467 3 22 7.25329 22 12.5C22 14.718 21.2399 16.7584 19.966 18.375L26.9785 25.3875L25.3875 26.9785L18.375 19.966ZM19.75 12.5C19.75 8.49594 16.5041 5.25 12.5 5.25C8.49594 5.25 5.25 8.49594 5.25 12.5C5.25 16.5041 8.49594 19.75 12.5 19.75C16.5041 19.75 19.75 16.5041 19.75 12.5Z"
      fill="currentColor"
    />
    <line x1="12.5" y1="7" x2="12.5" y2="18" stroke="currentColor" strokeWidth="2" />
    <line x1="7" y1="12.5" x2="18" y2="12.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const SvgIcon = ({ onClick, style, icon }) => (
  <Button variant="secondary" onClick={onClick} style={style}>
    {icon}
  </Button>
);

SvgIcon.propTypes = {
  onClick: func,
  // eslint-disable-next-line react/forbid-prop-types
  style: object,
  icon: oneOfType([node, func]).isRequired
};

SvgIcon.defaultProps = {
  onClick: _noop,
  style: {}
};
